module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0133.jpg?v=f14ef33b";